var chunkToChildrenMap = {
	"1351": [
		8096
	],
	"2076": [
		8096
	],
	"4120": [
		8096
	],
	"5112": [
		109,
		6140
	],
	"5368": [
		7919,
		109,
		6140,
		5898
	],
	"8034": [
		8096
	],
	"8182": [
		8096
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));